import { render, staticRenderFns } from "./progDetail.vue?vue&type=template&id=945b649a&scoped=true"
import script from "./progDetail.vue?vue&type=script&lang=js"
export * from "./progDetail.vue?vue&type=script&lang=js"
import style0 from "./progDetail.vue?vue&type=style&index=0&id=945b649a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945b649a",
  null
  
)

export default component.exports